import { render, staticRenderFns } from "./KnowStep.vue?vue&type=template&id=1d736078&scoped=true&"
import script from "./KnowStep.vue?vue&type=script&lang=js&"
export * from "./KnowStep.vue?vue&type=script&lang=js&"
import style0 from "./KnowStep.vue?vue&type=style&index=0&id=1d736078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d736078",
  null
  
)

export default component.exports